import React from 'react';
import { AuthProvider } from './context/AuthContext';
import App from './App';

// Conditionally wrap with GoogleOAuthProvider only when client ID is configured
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

let GoogleOAuthProvider = ({ children }) => children;

if (GOOGLE_CLIENT_ID) {
  try {
    // Dynamic-like usage: the provider is always imported, but only activated when ID is set
    const { GoogleOAuthProvider: G } = require('@react-oauth/google');
    GoogleOAuthProvider = G;
  } catch {
    // @react-oauth/google not installed — skip Google OAuth
  }
}

export default function AppWrapper() {
  const content = (
    <AuthProvider>
      <App />
    </AuthProvider>
  );

  if (GOOGLE_CLIENT_ID) {
    return (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        {content}
      </GoogleOAuthProvider>
    );
  }

  return content;
}
